import { createVNode as f, isVNode as h } from "vue";
import b from "./Icon.js";
function S(t) {
  return typeof t == "function" || Object.prototype.toString.call(t) === "[object Object]" && !h(t);
}
const u = /* @__PURE__ */ new Set();
function g(t) {
  return typeof t == "string" && t.length && !u.has(t);
}
function c(t, n = 0) {
  const o = t[n];
  if (g(o)) {
    const e = document.createElement("script");
    e.setAttribute("src", o), e.setAttribute("data-namespace", o), t.length > n + 1 && (e.onload = () => {
      c(t, n + 1);
    }, e.onerror = () => {
      c(t, n + 1);
    }), u.add(o), document.body.appendChild(e);
  }
}
function N(t = {}) {
  const {
    scriptUrl: n,
    extraCommonProps: o = {}
  } = t;
  typeof document < "u" && typeof window < "u" && typeof document.createElement == "function" && (Array.isArray(n) ? c(n.reverse()) : c([n]));
  const e = (l, p) => {
    const {
      attrs: d,
      slots: s
    } = p, {
      type: a,
      ...m
    } = {
      ...l,
      ...d
    }, i = s.default && s.default();
    let r = null;
    a && (r = f("use", {
      "xlink:href": `#${a}`
    }, null)), i && i.length && (r = i);
    const y = {
      ...o,
      ...m
    };
    return f(b, y, S(r) ? r : {
      default: () => [r]
    });
  };
  return e.props = {
    spin: Boolean,
    rotate: Number,
    type: String
  }, e.inheritAttrs = !1, e.displayName = "Iconfont", e;
}
export {
  N as default
};
